import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, FormLabel, Grid, TextField, Menu, MenuItem, Stack, Typography } from '@mui/material';

// project import
import ProfileTab from './ProfileTab';
import MainCard from '../../../../Components/MainCard';
import IconButton from '../../../../Components/IconButton';
import Avatar from '../../../../Components/@extended/Avatar';

import { FacebookFilled, LinkedinFilled, MoreOutlined, TwitterSquareFilled, CameraOutlined } from '@ant-design/icons';
import avatar1 from '../../../../assets/landing/genai343.jpg';
const ProfileTabs = ({ focusInput }) => {
  const theme = useTheme();
  const [selectedImage, setSelectedImage] = useState(undefined);
  const [avatar, setAvatar] = useState(avatar1);
  const user_attributes = useSelector((state) => {
      return state.authuser.user_attributes
  })

  useEffect(() => {
    if (selectedImage) {
      setAvatar(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <MainCard>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end">
            <IconButton
              variant="light"
              color="secondary"
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <MoreOutlined />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button'
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <MenuItem
                component={Link}
                to="/profiles/user/personal"
                onClick={() => {
                  handleClose();
                  setTimeout(() => {
                    focusInput();
                  });
                }}
              >
                Edit
              </MenuItem>
              <MenuItem onClick={handleClose} disabled>
                Delete
              </MenuItem>
            </Menu>
          </Stack>
          <Stack spacing={2.5} alignItems="center">
            <FormLabel
              htmlFor="change-avtar"
              sx={{
                position: 'relative',
                borderRadius: '50%',
                overflow: 'hidden',
                '&:hover .MuiBox-root': { opacity: 1 },
                cursor: 'pointer'
              }}
            >
              <Avatar alt="Avatar 1" src={avatar} sx={{ width: 124, height: 124, border: '1px dashed' }} />
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  backgroundColor: 'rgba(255, 255, 255, .75)',
                  width: '100%',
                  height: '100%',
                  opacity: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {/*<Stack spacing={0.5} alignItems="center">*/}
                {/*  <CameraOutlined style={{ color: theme.palette.secondary.lighter, fontSize: '2rem' }} />*/}
                {/*  <Typography sx={{ color: 'secondary.lighter' }}>Upload</Typography>*/}
                {/*</Stack>*/}
              </Box>
            </FormLabel>
            {/*<TextField*/}
            {/*  type="file"*/}
            {/*  id="change-avtar"*/}
            {/*  placeholder="Outlined"*/}
            {/*  variant="outlined"*/}
            {/*  sx={{ display: 'none' }}*/}
            {/*  onChange={(e) => setSelectedImage(e.target.files?.[0])}*/}
            {/*/>*/}
            <Stack spacing={0.5} alignItems="center">
              <Typography variant="h5">{user_attributes['given_name']?user_attributes['given_name']:""} {user_attributes['middle_name']?user_attributes['middle_name']:""} {user_attributes['family_name']?user_attributes['family_name']:""}</Typography>
            </Stack>
          </Stack>
        </Grid>
        <Grid item sm={3} sx={{ display: { sm: 'block', md: 'none' } }} />
        <Grid item xs={12}>
          <ProfileTab />
        </Grid>
      </Grid>
    </MainCard>
  );

}

ProfileTabs.propTypes = {
  focusInput: PropTypes.func
};

export default ProfileTabs;
